import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import api from '../../../app/api/api';
import { fetchRestaurantUserListAsync } from './restaurantUserListSlice';
import { UpdateRestaurantUserFormData } from '../../../app/data/models/restaurantUsers/restaurantUserFormdata';

export const updateRestaurantUserAsync = createAsyncThunk<
  void,
  { restaurantId: string; data: UpdateRestaurantUserFormData }
>('restaurantUsers/update', async ({ restaurantId, data }, thunkApi) => {
  try {
    await api.RestaurantUser.update(restaurantId, data);
    thunkApi.dispatch(fetchRestaurantUserListAsync({ restaurantId }));
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return thunkApi.rejectWithValue({ error: error.response?.data });
    }
    return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
  }
});
